var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSellos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.488,
    height: 192.608,
    viewBox: "0 0 162.488 192.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_583",
    "data-name": "Grupo 583",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_928",
    "data-name": "Trazado 928",
    d: "M873.843,411.563H713.829a1.237,1.237,0,1,1,0-2.474H873.843a1.237,1.237,0,0,1,0,2.474Z",
    transform: "translate(-712.592 -254.843)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_929",
    "data-name": "Trazado 929",
    d: "M814.465,268.768H752.241a13.128,13.128,0,0,1-13.114-13.114V193.43a13.129,13.129,0,0,1,13.114-13.113h62.224a13.129,13.129,0,0,1,13.114,13.113v62.224A13.129,13.129,0,0,1,814.465,268.768Z",
    transform: "translate(-721.238 -180.316)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_930",
    "data-name": "Trazado 930",
    d: "M871.2,311.568H808.981a13.129,13.129,0,0,1-13.114-13.113V236.23a13.129,13.129,0,0,1,13.114-13.114H871.2a13.129,13.129,0,0,1,13.114,13.114v62.224A13.129,13.129,0,0,1,871.2,311.568Z",
    transform: "translate(-739.72 -194.261)",
    fill: "#faf8f8",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_931",
    "data-name": "Trazado 931",
    d: "M748.142,459.149a.674.674,0,0,1-.674-.674V446.338a.674.674,0,1,1,1.348,0v12.136a.674.674,0,0,1-.674.674Z",
    transform: "translate(-723.954 -266.759)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_932",
    "data-name": "Trazado 932",
    d: "M829.642,459.149a.674.674,0,0,1-.674-.674V446.338a.674.674,0,1,1,1.348,0v12.136A.674.674,0,0,1,829.642,459.149Z",
    transform: "translate(-750.505 -266.759)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_933",
    "data-name": "Trazado 933",
    d: "M836.642,459.149a.674.674,0,0,1-.674-.674V446.338a.674.674,0,1,1,1.348,0v12.136A.674.674,0,0,1,836.642,459.149Z",
    transform: "translate(-752.785 -266.759)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_934",
    "data-name": "Trazado 934",
    d: "M758.528,459.263a1.558,1.558,0,0,1-.782-.212l-8.019-5.408-.045-.028a1.528,1.528,0,0,1-.714-1.313,1.548,1.548,0,0,1,.782-1.355l7.956-5.37a1.563,1.563,0,0,1,2.386,1.33V457.7A1.57,1.57,0,0,1,758.528,459.263Zm-.068-1.355a.206.206,0,0,0,.176-.025.21.21,0,0,0,.108-.187v-10.79a.216.216,0,0,0-.324-.187l-7.956,5.37c-.134.079-.148.165-.148.212a.21.21,0,0,0,.108.187l.04.025Z",
    transform: "translate(-724.443 -266.655)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_935",
    "data-name": "Trazado 935",
    d: "M916.142,459.149a.674.674,0,0,1-.674-.674V446.338a.674.674,0,1,1,1.348,0v12.136A.674.674,0,0,1,916.142,459.149Z",
    transform: "translate(-778.683 -266.759)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_936",
    "data-name": "Trazado 936",
    d: "M901.02,459.26a1.533,1.533,0,0,1-.77-.209,1.549,1.549,0,0,1-.782-1.355v-10.79a1.564,1.564,0,0,1,2.346-1.354l8.036,5.42a1.525,1.525,0,0,1,.742,1.33,1.547,1.547,0,0,1-.759,1.341l-7.979,5.384A1.659,1.659,0,0,1,901.02,459.26Zm-.2-1.564a.216.216,0,0,0,.323.187l7.987-5.39a.229.229,0,0,0,.118-.192h0a.21.21,0,0,0-.108-.187l-8.037-5.42a.2.2,0,0,0-.176.025.209.209,0,0,0-.108.187Z",
    transform: "translate(-773.473 -266.655)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_107",
    "data-name": "Elipse 107",
    cx: 8.091,
    cy: 8.091,
    rx: 8.091,
    ry: 8.091,
    transform: "translate(37.672 147.39)",
    fill: "#ef7a90"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellos);
export default __webpack_public_path__ + "static/media/sellos.99dae1d8fd75d50fba6617d9eee3cff4.svg";
export { ForwardRef as ReactComponent };